// project imports
import OptimizationStore from "../../../../../modules/optimization/store/OptimizationStore"
import * as keys from "./keys";
import * as APITypes from "../../../../../constants/API";
import ProductConstants from "constants/ProductConstants";
import axios from "axios";
class Utils {
  // ! ppt list funtion
  pptListBasedOnPlanOption(planOption) {
    let pptList = [
      { label: '8', id: 8 },
      { label: '10', id: 10 },
      { label: '12', id: 12 },
    ]

    // if (planOption === 3) {
    //   pptList.splice(0, 0, { label: '5', id: 5 });
    // }

    return pptList
  }
  // !incomeStartYear list function
  incomeStartYearOptionList(planOption, ppt) {
    let incomeStartYear = [
      { label: '2', id: 4 },
      { label: '5', id: 5 }
    ]

    if (planOption !== 3) {
      if (ppt === 8) { incomeStartYear.push({ label: '9', id: 6 }) }
      if (ppt === 10) { incomeStartYear.push({ label: '11', id: 7 }) }
      if (ppt === 12) { incomeStartYear.push({ label: '13', id: 8 }) }
      if (ppt === 15) { incomeStartYear.push({ label: '16', id: 9 }) }
    } else {
      incomeStartYear = []
    }
    return incomeStartYear
  }
  // !PT List
  policyTermList(planOption, ppt, age) {
    let ptList = []

    if (planOption === 3) {
      ptList = [
        { label: '20', id: 20 },
        { label: '25', id: 25 },
        { label: '30', id: 30 }
      ]

      if (ppt === 5 || ppt === 8) {
        ptList.splice(0, 0, { label: '10', id: 10 });
        ptList.splice(1, 0, { label: '15', id: 15 });
      }
      if (ppt === 10 || ppt === 12) {
        ptList.splice(0, 0, { label: '15', id: 15 });
      }

    } else {
      ptList = [
        { label: '30', id: 30 },
        { label: '40', id: 40 },
        { label: 100 - age, id: '100-@LI_ENTRY_AGE' }
      ]
    }
    return ptList
  }
  // !Life Cover Continuation Benefit
  checkLifeCoverDisabled(ppt, pt, age) {
    let isCoverDisabled = false
    if (ppt >= 10 && pt >= 20 && (age + pt <= 75)) {
      isCoverDisabled = false
    } else {
      isCoverDisabled = true
    }
    return isCoverDisabled
  }
  // ! update BI data
  updateBi = async (key, value, package_id, form, productData) => {

    let biData = OptimizationStore.fetchBiRequestForCompareProduct(
      package_id,
      productData?.data?.family_product_id
    );
    let biRequest = biData.data.bi_request;
    let updatedValue = value
    switch (key) {

      case keys.PR_PPT:
        biRequest[keys.PR_PPT] = value.ppt
        // biRequest[keys.INCOME_START_YEAR] = value.incomeStartYear;
        // biRequest[keys.PR_PT] = value.pt;
        // biRequest[keys.LIFE_COVER_CONTINUATION_BENEFIT] = value.lifeCoverContinuationBenefit
        updatedValue = value.ppt
        break;

      case keys.INCOME_START_YEAR:
        biRequest[keys.INCOME_START_YEAR] = value
        break;

      case keys.PR_PT:
        biRequest[keys.PR_PT] = value.pt;
        biRequest[keys.LIFE_COVER_CONTINUATION_BENEFIT] = value.lifeCoverContinuationBenefit
        updatedValue = value.pt
        break;

      case keys.LIFE_COVER_CONTINUATION_BENEFIT:
        biRequest[keys.LIFE_COVER_CONTINUATION_BENEFIT] = value
        break;

      case keys.FREQUENCY:
        biRequest[keys.FREQUENCY] = value
        break;

      case keys.ACCRUALOFSURVIVALBENEFIT_1:
        biRequest[keys.ACCRUALOFSURVIVALBENEFIT_1] = value.asb1;
        biRequest[keys.ASB_STARTPOLICYYEAR_1] = value.asbStartYear1;
        biRequest[keys.ASB_ENDPOLICYYEAR_1] = value.asbEndYear1;
        biRequest[keys.ACCRUALOFSURVIVALBENEFIT_2] = value.asb2;
        biRequest[keys.ASB_STARTPOLICYYEAR_2] = value.asbStartYear2;
        biRequest[keys.ASB_ENDPOLICYYEAR_2] = value.asbEndYear2;
        biRequest[keys.ACCRUALOFSURVIVALBENEFIT_3] = value.asb3;
        biRequest[keys.ASB_STARTPOLICYYEAR_3] = value.asbStartYear3;
        biRequest[keys.ASB_ENDPOLICYYEAR_3] = value.asbEndYear3;
        break;

      case keys.ASB_STARTPOLICYYEAR_1:
        biRequest[keys.ASB_STARTPOLICYYEAR_1] = value.asbStart1
        biRequest[keys.ASB_ENDPOLICYYEAR_1] = value.asbEnd1;
        biRequest[keys.ACCRUALOFSURVIVALBENEFIT_2] = value.asb2;
        biRequest[keys.ASB_STARTPOLICYYEAR_2] = value.asbStartYear2;
        biRequest[keys.ASB_ENDPOLICYYEAR_2] = value.asbEndYear2;
        biRequest[keys.ACCRUALOFSURVIVALBENEFIT_3] = value.asb3;
        biRequest[keys.ASB_STARTPOLICYYEAR_3] = value.asbStartYear3;
        biRequest[keys.ASB_ENDPOLICYYEAR_3] = value.asbEndYear3;
        break;

      case keys.ASB_ENDPOLICYYEAR_1:
        biRequest[keys.ASB_ENDPOLICYYEAR_1] = value.asbEnd1;
        biRequest[keys.ACCRUALOFSURVIVALBENEFIT_2] = value.asb2;
        biRequest[keys.ASB_STARTPOLICYYEAR_2] = value.asbStartYear2;
        biRequest[keys.ASB_ENDPOLICYYEAR_2] = value.asbEndYear2;
        biRequest[keys.ACCRUALOFSURVIVALBENEFIT_3] = value.asb3;
        biRequest[keys.ASB_STARTPOLICYYEAR_3] = value.asbStartYear3;
        biRequest[keys.ASB_ENDPOLICYYEAR_3] = value.asbEndYear3;

        break;

      case keys.ASB_WITHDRAWALPERCENTAGE_1:

        biRequest[keys.ASB_WITHDRAWALPERCENTAGE_1] = value

        break

      case keys.ACCRUALOFSURVIVALBENEFIT_2:
        biRequest[keys.ACCRUALOFSURVIVALBENEFIT_2] = value.asb2
        biRequest[keys.ASB_STARTPOLICYYEAR_2] = value.asbStartYear2;
        biRequest[keys.ASB_ENDPOLICYYEAR_2] = value.asbEndYear2;
        biRequest[keys.ACCRUALOFSURVIVALBENEFIT_3] = value.asb3;
        biRequest[keys.ASB_STARTPOLICYYEAR_3] = value.asbStartYear3;
        biRequest[keys.ASB_ENDPOLICYYEAR_3] = value.asbEndYear3;
        break;

      case keys.ASB_STARTPOLICYYEAR_2:
        biRequest[keys.ASB_STARTPOLICYYEAR_2] = value.asbStartYear2;
        biRequest[keys.ASB_ENDPOLICYYEAR_2] = value.asbEndYear2;
        biRequest[keys.ACCRUALOFSURVIVALBENEFIT_3] = value.asb3;
        biRequest[keys.ASB_STARTPOLICYYEAR_3] = value.asbStartYear3;
        biRequest[keys.ASB_ENDPOLICYYEAR_3] = value.asbEndYear3;
        break;

      case keys.ASB_ENDPOLICYYEAR_2:
        biRequest[keys.ASB_ENDPOLICYYEAR_2] = value.asbEndYear2;
        biRequest[keys.ACCRUALOFSURVIVALBENEFIT_3] = value.asb3;
        biRequest[keys.ASB_STARTPOLICYYEAR_3] = value.asbStartYear3;
        biRequest[keys.ASB_ENDPOLICYYEAR_3] = value.asbEndYear3;
        break;

      case keys.ASB_WITHDRAWALPERCENTAGE_2:
        biRequest[keys.ASB_WITHDRAWALPERCENTAGE_2] = value

        break

      case keys.ACCRUALOFSURVIVALBENEFIT_3:
        biRequest[keys.ACCRUALOFSURVIVALBENEFIT_3] = value.asb3;
        biRequest[keys.ASB_STARTPOLICYYEAR_3] = value.asbStartYear3;
        biRequest[keys.ASB_ENDPOLICYYEAR_3] = value.asbEndYear3;
        break;

      case keys.ASB_STARTPOLICYYEAR_3:
        biRequest[keys.ASB_STARTPOLICYYEAR_3] = value.asbStartYear3
        biRequest[keys.ASB_ENDPOLICYYEAR_3] = value.asbEndYear3
        break;

      case keys.ASB_ENDPOLICYYEAR_3:
        biRequest[keys.ASB_ENDPOLICYYEAR_3] = value.asbEndYear3;
        break;

      case keys.ASB_WITHDRAWALPERCENTAGE_3:
        biRequest[keys.ASB_WITHDRAWALPERCENTAGE_3] = value

        break

      case keys.SECOND_LIFE_ASSURED_NAME:
        biRequest[keys.SECOND_LIFE_ASSURED_NAME] = value;
        break;

      case keys.SECOND_LIFE_ASSURED_LAST_NAME:
        biRequest[keys.SECOND_LIFE_ASSURED_LAST_NAME] = value;
        break;
      case keys.SECOND_LIFE_ASSURED_GENDER:
        biRequest[keys.SECOND_LIFE_ASSURED_GENDER] = value;
        break;

      case keys.SecLaDOB:
        biRequest[keys.SecLaDOB] = value;
        break;

      case keys.PLAN_OPTION:

        biRequest[keys.SECOND_LIFE_ASSURED_NAME] = value.SecondLifeAssuredName
        biRequest[keys.SECOND_LIFE_ASSURED_LAST_NAME] = value.SecondLifeAssuredLastName
        biRequest[keys.SecLaDOB] = value.SecLaDOB
        biRequest[keys.SECOND_LIFE_ASSURED_GENDER] = value.secondLifeAssuredGender
        biRequest[keys.PLAN_OPTION] = value.planOption
        updatedValue = value.planOption
        break;

      case keys.PERSONALISED_OPTION:
        biRequest[keys.PERSONALISED_OPTION] = value.personalizePlan
        biRequest[keys.WITHDRAWAL] = value.systematicWithdrawal
        biRequest[keys.WITHDRAWAL_START_YEAR] = value.pwStartYear
        biRequest[keys.WITHDRAWAL_STOP_YEAR] = value.pwEndYear
        biRequest[keys.AGE_BASED_WITHDRAWAL] = value.pwAge
        biRequest[keys.START_AGE] = value.pwStartAge
        biRequest[keys.END_AGE] = value.pwEndAge
        updatedValue = value.personalizePlan
        break;

      case keys.WITHDRAWAL:
        biRequest[keys.WITHDRAWAL] = value
        break;

      case keys.WITHDRAWAL_START_YEAR:
        biRequest[keys.WITHDRAWAL_START_YEAR] = value
        break;

      case keys.WITHDRAWAL_STOP_YEAR:
        biRequest[keys.WITHDRAWAL_STOP_YEAR] = value
        break;

      case keys.AGE_BASED_WITHDRAWAL:
        biRequest[keys.AGE_BASED_WITHDRAWAL] = value
        break;

      case keys.START_AGE:
        biRequest[keys.START_AGE] = value
        break;

      case keys.END_AGE:
        biRequest[keys.END_AGE] = value
        break;

      case keys.WOP_RIDER:
        biRequest[keys.WOP_RIDER] = value;
        break;

      case keys.ADB_RIDER:
        if (value) {
          biRequest[keys.ADB_RIDER] = value;
        } else {
          biRequest[keys.ADB_RIDER] = "";
        }
        break;

      case keys.ATPD_RIDER:
        if (value) {
          biRequest[keys.ATPD_RIDER] = value;
        } else {
          biRequest[keys.ATPD_RIDER] = "";
        }
        break;

      case keys.Critical_ILLNESS_RIDER:
        if (value) {
          biRequest[keys.Critical_ILLNESS_RIDER] = value;
        } else {
          biRequest[keys.Critical_ILLNESS_RIDER] = "";
        }
        break;

      case keys.INCOME_BENEFIT_RIDER:
        if (value) {
          biRequest[keys.INCOME_BENEFIT_RIDER] = value;
        } else {
          biRequest[keys.INCOME_BENEFIT_RIDER] = "";
        }
        break;

      case keys.PWB_RIDER:
        if (value) {
          biRequest[keys.PWB_RIDER] = "1";
          biRequest.PWB = "" + value;
        } else {
          biRequest[keys.PWB_RIDER] = "";
        }
        break;
    }
    if (Number(biRequest[keys.ACCRUALOFSURVIVALBENEFIT_1]) === 7) {
      biRequest["SampleBI"] = "true"
    } else {
      biRequest["SampleBI"] = "false"
    }
    OptimizationStore.updateBiRequestForComapareProduct(
      package_id,
      biRequest,
      productData.data.family_product_id,
      key,
      updatedValue,
    );
    };

  onChangeWithDrawal(value, key, listIndex, form) {
    let list = form.$(`${key}`).extra.optionList
    let optionList = []
    list.forEach((item, index) => {
      if (index === listIndex) {
        optionList.push(value)
      } else {
        optionList.push(item)
      }
    });
    return optionList
  }

  addMoreFields(form, key) {
    let valueNotEntered = false

    let optionList = form.$(`${key}`).extra.optionList
    optionList.forEach((item) => {
      if (item === "" && !valueNotEntered) {
        valueNotEntered = true
      }
    })

    if (!valueNotEntered) {
      optionList.push("");
      form.$(`${key}`).set('extra', { ...form.$(`${key}`).extra, optionList })
    }
  }

  onResetFields(form, key) {
    let optionList = [""]
    form.$(`${key}`).set('extra', {
      ...form.$(`${key}`).extra, optionList
    })
  }

  getTotalPrice = (biResponse) => {
    try {
      return Number(biResponse?.MODAL_PREM_TAX)
    } catch (e) {
      return 0
    }
  }


  newPolicyTimeLineData(element, inputString, index, productName, sampleBiData, showOldBiDetails, finalYearIndex,finalOutputJSon, familyMemberId, secondaryLaId) {

    let youGet = 0
    let lifeCover = 0
    let youPay = 0
    switch (productName) {
      case ProductConstants.LEGACY_PLUS_INCOME:
      case ProductConstants.LEGACY_PLUS_LUMPSUM:
        if (Number(familyMemberId) === Number(secondaryLaId)) {
          youGet = 0
        } else {
          if (index === finalYearIndex) {
            youGet = Math.round(element.TOTAL_SB_G_BS_2 + element.PAYOUT_ACC_SB_G_BS_2 + element.TOTAL_MB_G_BS_2)
          } else {
            youGet = Math.round(element.TOTAL_SB_G_BS_2 + element.PAYOUT_ACC_SB_G_BS_2)

          }
        }

        if (Number(familyMemberId) === Number(secondaryLaId)) {
          lifeCover = Math.round(element.DB_SL)
          youPay = 0
        } else {
          lifeCover = Math.round(element.DB_PL)
          youPay =  Math.round(element.ANN_PREM_YEARLY)
        }
        break;
    }

    let data = {
      youPay: Math.round(youPay),
      youGet: Math.round(youGet),
      lifeCover: Math.round(lifeCover),
    };
    return data;
  }

  swpEndYearList(withdrawalType, startYear, pt) {
    let endYearList = []
    let endYear = 0
    for (let i = 0; i <= pt; i++) {
      if (i === Number(withdrawalType) + Number(startYear)) {
        endYear = Number(withdrawalType) + Number(startYear)
        endYearList.push(Number(withdrawalType) + Number(startYear))
      }

      if (endYearList.length !== 0) {
        endYear += withdrawalType
        if (endYear <= pt) {
          endYearList.push(endYear)
        }
      }
    }

    return endYearList
  }

  generatePredefinedOptListForLP(firstId, optionId) {
    let startOptId = optionId
    let list = []
    for (let i = firstId; i < 100; i++) {
      list.push({
        id: startOptId,
        label: i,
      });
      startOptId += 1
    }
    return list
  }

  generatePredefinedOptListForWithDrawalParcentage(firstId, optionId) {
    let startOptId = optionId
    let list = []
    for (let i = firstId; i <= 100; i++) {
      list.push({
        id: startOptId,
        label: i + '%',
      });
      startOptId += 1
    }
    return list
  }


  setHideAndResetValue(formRef, key, value, noOptParamValue) {
    formRef.$(key).set("extra", { ...formRef.$(key).extra, hide: value });
    if (noOptParamValue) {
      formRef.$(key).set("value", { label: "No", id: noOptParamValue });
    } else {
      formRef.$(key).set("value", "");
    }
  }

  handleASBstartPolicyOneConditions(formRef, productName, PT_value, liAge) {

    if (Number(formRef.$("accrual-of-survival-benefit").value.id) == 6) {
      let asbStartYearOneList = this.fetchASBstartPolicyOne(
        formRef.$("plan-option").value.id,
        PT_value,
        formRef.$("premium-term").value.id,
        formRef.$("asb-start-age-(1st-opt-in)").extra.preDefinedOptList,
        liAge
      );

      console.log("asbStartYearOneList ", asbStartYearOneList)

      formRef.$("asb-start-age-(1st-opt-in)").set("extra", {
        ...formRef.$("asb-start-age-(1st-opt-in)").extra,
        optionList: asbStartYearOneList,
      });
      formRef.$("asb-start-age-(1st-opt-in)").set("value", asbStartYearOneList[0]);


      let selectedAsbStartYearOne = asbStartYearOneList.some(
        (item) =>
          item.id === formRef.$("asb-start-age-(1st-opt-in)").value.id
      );
      // if (productName === ProductConstants.BHARAT_SAVINGS_STAR_LUMPSUM ||
      //   productName === ProductConstants.POS_BHARAT_SAVINGS_STAR_LUMPSUM) {
      //   if (Number(formRef.$("plan-option").value.id) === 2) {
      //     let selectedAsbStartYearOne = asbStartYearOneList.some(
      //       (item) =>
      //         Number(item.label) === Number(formRef.$("premium-paying-term").value.label)
      //     );
      //     if (selectedAsbStartYearOne) {
      //       formRef.$("asb-start-age-(1st-opt-in)").set("value", asbStartYearOneList.find(
      //         (item) =>
      //           Number(item.label) === Number(formRef.$("premium-paying-term").value.label)
      //       ));
      //     } else {
      //       formRef.$("asb-start-age-(1st-opt-in)").set("value", asbStartYearOneList[0]);
      //     }

      //   } else {
      //     formRef.$("asb-start-age-(1st-opt-in)").set("value", asbStartYearOneList[0]);
      //   }
      // } else {
      //   formRef
      //     .$("asb-start-age-(1st-opt-in)")
      //     .set("value", asbStartYearOneList[0]);
      // }
      // if (!selectedAsbStartYearOne) {
      // }

      let asbEndYearOneList = this.fetchASBendPolicyOne(
        formRef.$("asb-start-age-(1st-opt-in)").value.id,
        asbStartYearOneList,
        formRef.$("asb-end-age-(1st-opt-in)").extra.preDefinedOptList
      );

      formRef.$("asb-end-age-(1st-opt-in)").set("extra", {
        ...formRef.$("asb-end-age-(1st-opt-in)").extra,
        optionList: asbEndYearOneList,
      });

      let selectedAsbEndYearOne = asbEndYearOneList.some(
        (item) =>
          item.id === formRef.$("asb-end-age-(1st-opt-in)").value.id
      );
      // if (!selectedAsbEndYearOne) {
      formRef
        .$("asb-end-age-(1st-opt-in)")
        .set("value", asbEndYearOneList[asbEndYearOneList.length - 1]);
      // }
    }
  }


  // handled ASB 1
  handleAsbCondition(formRef, asb1Value) {

    if (Number(asb1Value) === 7) {
      this.setHideAndResetValue(formRef, "asb-start-age-(1st-opt-in)", true);
      this.setHideAndResetValue(formRef, "asb-end-age-(1st-opt-in)", true);
      this.setHideAndResetValue(formRef, "withdrawal-parcentage-1", true);
      this.setHideAndResetValue(formRef, "accrual-of-survival-benefits-year-2", true, 321);
      this.setHideAndResetValue(formRef, "asb-start-age-(2nd-opt-in)", true);
      this.setHideAndResetValue(formRef, "asb-end-age-(2nd-opt-in)", true);
      this.setHideAndResetValue(formRef, "withdrawal-parcentage-2", true);
      this.setHideAndResetValue(formRef, "accrual-of-survival-benefits-year-3", true, 626);
      this.setHideAndResetValue(formRef, "asb-start-age-(3rd-opt-in)", true);
      this.setHideAndResetValue(formRef, "asb-end-age-(3rd-opt-in)", true);
      this.setHideAndResetValue(formRef, "withdrawal-parcentage-3", true);
    } else {
      this.setHideAndResetValue(formRef, "asb-start-age-(1st-opt-in)", false);
      this.setHideAndResetValue(formRef, "asb-end-age-(1st-opt-in)", false);
      this.setHideAndResetValue(formRef, "withdrawal-parcentage-1", false);
      this.setHideAndResetValue(formRef, "accrual-of-survival-benefits-year-2", false, 321);
      this.setHideAndResetValue(formRef, "asb-start-age-(2nd-opt-in)", true);
      this.setHideAndResetValue(formRef, "asb-end-age-(2nd-opt-in)", true);
      this.setHideAndResetValue(formRef, "withdrawal-parcentage-2", true);
      this.setHideAndResetValue(formRef, "accrual-of-survival-benefits-year-3", true, 626);
      this.setHideAndResetValue(formRef, "asb-start-age-(3rd-opt-in)", true);
      this.setHideAndResetValue(formRef, "asb-end-age-(3rd-opt-in)", true);
      this.setHideAndResetValue(formRef, "withdrawal-parcentage-3", true);
    }
  }

  // handled ASB start year 1
  fetchASBstartPolicyOne(planOption, pt, ppt, preDefinedOptList, liAge) {
    let startYearList = [];
    // let value = Number(pt) === 40 ? Number(pt) - 1 : Number(pt);
    let value = Number(pt) - 1;
    let startPoint = liAge;
    // if (Number(planOption) === 2) startPoint = Number(Number(ppt) + 2);
    for (let i = startPoint; i < 100; i++) {
      let optData = preDefinedOptList.find((item) => item.label === i)
      startYearList.push(optData);
    }
    return startYearList;
  }

  // handled ASB end year 1
  fetchASBendPolicyOne(startYear1, asbStartYearOneList, preDefinedOptList) {
    let endYearList = [];
    asbStartYearOneList.forEach((item) => {
      if (item.id >= startYear1) {
        let optData = preDefinedOptList.find((opt) => opt.label === item.label)
        endYearList.push(optData);
      }
    });
    return endYearList;
  }

  // handled ASB 2nd year condition
  handleAsbTwoCondition(formRef, asb2Value) {

    if (Number(asb2Value) === 321) {
      this.setHideAndResetValue(formRef, "asb-start-age-(2nd-opt-in)", true);
      this.setHideAndResetValue(formRef, "asb-end-age-(2nd-opt-in)", true);
      this.setHideAndResetValue(formRef, "withdrawal-parcentage-2", true);
      this.setHideAndResetValue(formRef, "accrual-of-survival-benefits-year-3", true, 626);
      this.setHideAndResetValue(formRef, "asb-start-age-(3rd-opt-in)", true);
      this.setHideAndResetValue(formRef, "asb-end-age-(3rd-opt-in)", true);
      this.setHideAndResetValue(formRef, "withdrawal-parcentage-3", true);
    } else {
      this.setHideAndResetValue(formRef, "asb-start-age-(2nd-opt-in)", false);
      this.setHideAndResetValue(formRef, "asb-end-age-(2nd-opt-in)", false);
      this.setHideAndResetValue(formRef, "withdrawal-parcentage-2", false);
      this.setHideAndResetValue(formRef, "accrual-of-survival-benefits-year-3", false, 626);
      this.setHideAndResetValue(formRef, "asb-start-age-(3rd-opt-in)", true);
      this.setHideAndResetValue(formRef, "asb-end-age-(3rd-opt-in)", true);
      this.setHideAndResetValue(formRef, "withdrawal-parcentage-3", true);

    }
  }

  // handled ASB end year 1
  fetchASBendPolicyOne(startYear1, asbStartYearOneList, preDefinedOptList) {
    let endYearList = [];
    asbStartYearOneList.forEach((item) => {
      if (item.id >= startYear1) {
        let optData = preDefinedOptList.find((opt) => opt.label === item.label)
        endYearList.push(optData);
      }
    });
    return endYearList;
  }

  // handled ASB 3rd year condition
  handleAsbThreeCondition(formRef, asb3Value) {

    if (Number(asb3Value) === 626) {
      this.setHideAndResetValue(formRef, "asb-start-age-(3rd-opt-in)", true);
      this.setHideAndResetValue(formRef, "asb-end-age-(3rd-opt-in)", true);
      this.setHideAndResetValue(formRef, "withdrawal-parcentage-3", true);

    } else {
      this.setHideAndResetValue(formRef, "asb-start-age-(3rd-opt-in)", false);
      this.setHideAndResetValue(formRef, "asb-end-age-(3rd-opt-in)", false);
      this.setHideAndResetValue(formRef, "withdrawal-parcentage-3", false);
    }
  }

  handleASBFirstStartEndCondition(formRef, asbValue) {

    if (Number(asbValue) === 7) {
      this.setHideAndResetValue(formRef, "accrual-of-survival-benefits-year-2", true, 321);
      this.setHideAndResetValue(formRef, "asb-start-age-(2nd-opt-in)", true);
      this.setHideAndResetValue(formRef, "asb-end-age-(2nd-opt-in)", true);
      this.setHideAndResetValue(formRef, "withdrawal-parcentage-2", true);
      this.setHideAndResetValue(formRef, "accrual-of-survival-benefits-year-3", true, 626);
      this.setHideAndResetValue(formRef, "asb-start-age-(3rd-opt-in)", true);
      this.setHideAndResetValue(formRef, "asb-end-age-(3rd-opt-in)", true);
      this.setHideAndResetValue(formRef, "withdrawal-parcentage-3", true);
    } else {
      this.setHideAndResetValue(formRef, "accrual-of-survival-benefits-year-2", false, 321);
      this.setHideAndResetValue(formRef, "asb-start-age-(2nd-opt-in)", true);
      this.setHideAndResetValue(formRef, "asb-end-age-(2nd-opt-in)", true);
      this.setHideAndResetValue(formRef, "withdrawal-parcentage-2", true);
      this.setHideAndResetValue(formRef, "accrual-of-survival-benefits-year-3", true, 626);
      this.setHideAndResetValue(formRef, "asb-start-age-(3rd-opt-in)", true);
      this.setHideAndResetValue(formRef, "asb-end-age-(3rd-opt-in)", true);
      this.setHideAndResetValue(formRef, "withdrawal-parcentage-3", true);
    }
  }

  handleASBTwostartPolicyOneConditions(formRef) {

    if (formRef.$("accrual-of-survival-benefits-year-2").value.id == 320) {
      let asbTwoStartYearOneList = this.fetchASBendPolicyOne(
        formRef.$("asb-end-age-(1st-opt-in)").value.id + 2,
        formRef.$("asb-end-age-(1st-opt-in)").extra.optionList,
        formRef.$("asb-start-age-(2nd-opt-in)").extra.preDefinedOptList
      );

      formRef.$("asb-start-age-(2nd-opt-in)").set("extra", {
        ...formRef.$("asb-start-age-(2nd-opt-in)").extra,
        optionList: asbTwoStartYearOneList,
      });

      let selectedAsbTwoStartYearOne = asbTwoStartYearOneList.some(
        (item) =>
          item.id === formRef.$("asb-start-age-(2nd-opt-in)").value.id
      );
      if (!selectedAsbTwoStartYearOne) {
        formRef
          .$("asb-start-age-(2nd-opt-in)")
          .set("value", asbTwoStartYearOneList[asbTwoStartYearOneList.length - 1]);
      }

      let asbTwoEndYearOneList = this.fetchASBendPolicyOne(
        formRef.$("asb-start-age-(2nd-opt-in)").value.id,
        asbTwoStartYearOneList,
        formRef.$("asb-end-age-(2nd-opt-in)").extra.preDefinedOptList
      );

      formRef.$("asb-end-age-(2nd-opt-in)").set("extra", {
        ...formRef.$("asb-end-age-(2nd-opt-in)").extra,
        optionList: asbTwoEndYearOneList,
      });

      let selectedAsbTwoEndYearOne = asbTwoEndYearOneList.some(
        (item) =>
          item.id === formRef.$("asb-end-age-(2nd-opt-in)").value.id
      );
      if (!selectedAsbTwoEndYearOne) {
        formRef
          .$("asb-end-age-(2nd-opt-in)")
          .set("value", asbTwoEndYearOneList[asbTwoEndYearOneList.length - 1]);
      }
    }
  }
  // Handled ASB 2 Start Year 
  handleASBTwoStartEndCondition(formRef, asbValue) {

    if (Number(asbValue) === 321) {
      this.setHideAndResetValue(formRef, "accrual-of-survival-benefits-year-3", true, 626);
      this.setHideAndResetValue(formRef, "asb-start-age-(3rd-opt-in)", true);
      this.setHideAndResetValue(formRef, "asb-end-age-(3rd-opt-in)", true);
    } else {
      this.setHideAndResetValue(formRef, "accrual-of-survival-benefits-year-3", false, 626);
      this.setHideAndResetValue(formRef, "asb-start-age-(3rd-opt-in)", true);
      this.setHideAndResetValue(formRef, "asb-end-age-(3rd-opt-in)", true);
    }
  }

  // Handled ASB 3 Start Year 
  handleASBThreestartPolicyOneConditions(formRef) {
    if (formRef.$("accrual-of-survival-benefits-year-3").value.id == 625) {
      let asbThreeStartYearOneList = this.fetchASBendPolicyOne(
        formRef.$("asb-end-age-(2nd-opt-in)").value.id + 2,
        formRef.$("asb-end-age-(2nd-opt-in)").extra.optionList,
        formRef.$("asb-start-age-(3rd-opt-in)").extra.preDefinedOptList
      );

      formRef.$("asb-start-age-(3rd-opt-in)").set("extra", {
        ...formRef.$("asb-start-age-(3rd-opt-in)").extra,
        optionList: asbThreeStartYearOneList,
      });

      let selectedAsbThreeStartYearOne = asbThreeStartYearOneList.some(
        (item) =>
          item.id === formRef.$("asb-start-age-(3rd-opt-in)").value.id
      );
      if (!selectedAsbThreeStartYearOne) {
        formRef
          .$("asb-start-age-(3rd-opt-in)")
          .set("value", asbThreeStartYearOneList[asbThreeStartYearOneList.length - 1]);
      }

      let asbThreeEndYearOneList = this.fetchASBendPolicyOne(
        formRef.$("asb-start-age-(3rd-opt-in)").value.id,
        asbThreeStartYearOneList,
        formRef.$("asb-end-age-(3rd-opt-in)").extra.preDefinedOptList
      );

      formRef.$("asb-end-age-(3rd-opt-in)").set("extra", {
        ...formRef.$("asb-end-age-(3rd-opt-in)").extra,
        optionList: asbThreeEndYearOneList,
      });

      let selectedAsbThreeEndYearOne = asbThreeEndYearOneList.some(
        (item) =>
          item.id === formRef.$("asb-end-age-(3rd-opt-in)").value.id
      );
      if (!selectedAsbThreeEndYearOne) {
        formRef
          .$("asb-end-age-(3rd-opt-in)")
          .set("value", asbThreeEndYearOneList[asbThreeEndYearOneList.length - 1]);
      }
    }
  }

  fetchNeedID(need) {

    if (need === "grow_my_money") {
      return 1;
    } else if (need === "save_for_children") {
      return 2
    } else if (need === "save_for_retirement") {
      return 3
    } else if (need === "protection_for_my_family") {
      return 4
    }
  }

  async fetchMinorDta(journeyId, needId, secondaryLAProduct, requiredLA) {

    const eligibleUserResponse = await axios.post(
      APITypes.GET_ELIGIBLE_LA_LIST,
      {
        journey_id: journeyId,
        need_id: needId,
        secondary_la_product: secondaryLAProduct,
        required_la: requiredLA
      }
    );


    eligibleUserResponse?.data
  }


}


export default new Utils();
